module.exports = __webpack_public_path__ + "static/img/logo4.219d7634.png";